// list of URLs that should be opened via a full refresh (don't use Nuxt/SPA)
const URL_EXTERNAL_WILDCARD = [
  '/collections/alternative-to/',
];

export default ({ app }) => {
  // add beforeEach handler once we are ready to avoid infinite loop
  app.router.onReady(() => {
    app.router.beforeEach((to, from, next) => {
      if (URL_EXTERNAL_WILDCARD.some((url) => to.path.startsWith(url))) {
        window.location.href = to.path;
      } else {
        next();
      }
    });
  });
};
